import React from 'react';
import styled from 'styled-components';
import { Button } from '@appcues/component-library';
import { TAG_MANAGEMENT_MODAL } from 'constants/globals';
import BaseModal from 'components/ModalContainer/BaseModal';

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  .button {
    margin-top: 10px;
    margin-right: 10px;

    &.delete-tag {
      background-color: ${props => props.theme['$red-1']};
      border-color: ${props => props.theme['$red-1']};
      color: white;
    }
  }
`;

const ConfirmationMessage = styled.div`
  margin: 0 0 15px 0;
`;

export default function ConfirmGlobalTagDeleteModal({
  actions,
  tag,
  numOfMatchingSteps,
}) {
  const handleCancel = () => {
    actions.showModal(TAG_MANAGEMENT_MODAL, {});
  };

  const handleSubmit = () => {
    actions.deleteTag(tag.id);
    actions.showModal(TAG_MANAGEMENT_MODAL, {});
  };

  const moreThanOneMatchingFlow = numOfMatchingSteps > 1;

  return (
    <BaseModal
      shouldHideButtonStyle
      hideOKButton
      actions={actions}
      modalClass="pending-modal"
    >
      <ConfirmationMessage>
        {`There ${
          moreThanOneMatchingFlow ? 'are' : 'is'
        } ${numOfMatchingSteps} flow${
          moreThanOneMatchingFlow ? 's' : ''
        } tagged with "${tag.name}". Are you sure you want to delete this tag?`}
      </ConfirmationMessage>
      <ButtonGroup>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleSubmit} className="delete-tag">
          Delete Tag
        </Button>
      </ButtonGroup>
    </BaseModal>
  );
}
